import { CartAddEvent } from '@theme/events';

const formatMoney = (cents) => {
  const currency = window.Shopify?.currency?.active || 'USD';
  const locale = document.documentElement.lang || 'en-US';
  return new Intl.NumberFormat(locale, { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
};

class RitualAddonModule extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.addEventListener('change', this.handleVariantChange);
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleVariantChange);
    this.removeEventListener('click', this.handleClick);
    delete this.dataset.initialized;
  }

  handleVariantChange = (event) => {
    const target = event.target;
    const select = target instanceof Element ? target.closest('[data-variant-select]') : null;
    if (!select) return;
    const card = select.closest('.ritual-addon-card');
    const option = select.selectedOptions[0];
    const cents = Number(option.dataset.priceCents || 0);
    const regularPrice = card.querySelector('[data-regular-price]');
    const ritualPrice = card.querySelector('[data-ritual-price]');
    const addButton = card.querySelector('[data-ritual-add]');
    if (regularPrice) regularPrice.textContent = formatMoney(cents);
    if (ritualPrice) ritualPrice.textContent = formatMoney(Math.round(cents / 2)) + ' Ritual Price';
    if (addButton) addButton.disabled = option.dataset.available !== 'true';
  };

  handleClick = async (event) => {
    const target = event.target;
    const button = target instanceof Element ? target.closest('[data-ritual-add]') : null;
    if (!button || button.disabled) return;
    const card = button.closest('.ritual-addon-card');
    const status = card.querySelector('[data-ritual-status]');
    const select = card.querySelector('[data-variant-select]');
    const singleVariant = card.querySelector('[data-single-variant]');
    const variantId = select ? select.value : singleVariant?.value;
    if (!variantId) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';
    if (status) status.textContent = '';

    try {
      const body = new URLSearchParams({
        id: variantId,
        quantity: '1',
        sections: this.dataset.sectionId,
        sections_url: window.location.pathname + window.location.search,
      });
      const addResponse = await fetch(this.dataset.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' },
        body,
      });
      const addData = await addResponse.json();
      if (!addResponse.ok) throw new Error(addData.description || addData.message || 'This item could not be added right now.');

      const cartResponse = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Your cart updated, but its latest details could not be loaded.');
      const cart = await cartResponse.json();
      this.dispatchEvent(new CartAddEvent(cart, this.id || 'ritual-addon-module', {
        source: 'ritual-addon-module',
        productId: card.dataset.productId,
        variantId: String(variantId),
        itemCount: cart.item_count,
        sections: addData.sections || {},
      }));
    } catch (error) {
      if (status) status.textContent = error.message || 'Please try adding this item again.';
      if (button.isConnected) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = 'Add';
      }
    }
  };
}

if (!customElements.get('ritual-addon-module')) {
  customElements.define('ritual-addon-module', RitualAddonModule);
}
